// extracted by mini-css-extract-plugin
module.exports = {"s1r8j59n":"s1r8j59n","w1spqdxo":"w1spqdxo","tegelh2":"tegelh2","tny3bu6":"tny3bu6","title":"title","l14i8ntl":"l14i8ntl","feedback":"feedback","app-icon":"app-icon"};